export default __webpack_public_path__ + "static/media/Yentra-logo.4ab616a1.png";